import React from 'react'
import { ChartBox } from '../../../../ResultPanel/component/ChartBox'
import SingleLineSeries from '../../../../../common/Chart/SingleLineChart'
import styles from '../../Layout/AnalyticsLayout.module.scss'
import {IBestDataset, IPlotVariable} from "../../../../../../types/analytics";
import {Empty, Spin} from "antd";
import ErrorDisplay from "../../ErrorDisplay";

interface TSPlotChartProps {
  tsPlotData: any[]
  pointName: string
  coordinates: { lng: string; lat: string }
  variable: IPlotVariable | null
  name: string
  selectedDatasetInfo?: IBestDataset
  isLoading?: boolean
  error?: string
  isOffline: boolean
  emptyData?: string
}

export const TimeSeriesChart = ({
  tsPlotData,
  pointName,
  coordinates,
  variable,
  name,
  selectedDatasetInfo,
  isLoading = false,
  error,
  isOffline,
  emptyData = 'No data available'
}: TSPlotChartProps) => {

  if (error || isOffline) {
    return (
      <ErrorDisplay
        error={error}
        isOfflineDataset={isOffline}
      />
    )
  }

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }}>
        <Spin />
      </div>
    )
  }

  if(tsPlotData.length === 0 || tsPlotData.length === 0){
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }}>
        <Empty description={emptyData} />
      </div>
    )
  }

  return (
    <div className={styles.chartPointWrapper}>
      <div className={styles.analyticsPointName}>
        {pointName}
        <span className={styles.analyticsCoords}>
          ({coordinates.lng}°E; {coordinates.lat}°N)
        </span>
      </div>

      <div className={styles.chartContainer}>
        <ChartBox
          key="Time Series Plot"
          title="Time Series Plot"
          height={350}
          plot={
            <SingleLineSeries
              id="Analytics-TimeSeries_Plot"
              data={tsPlotData}
              name={name}
              variable={`${variable?.Name} [${variable?.Unit}]`}
              color="#51628f"
            />
          }
          dataset={selectedDatasetInfo?.label || ''}
        />
      </div>
    </div>
  )
}

export type { TSPlotChartProps }
